import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19071c6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "manifold m-add-to-cart"
}
const _hoisted_2 = {
  key: 1,
  class: "manifold m-add-to-cart"
}
const _hoisted_3 = { class: "m-product-button-container" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_loading = _resolveComponent("m-loading")!
  const _component_m_discount_eligible = _resolveComponent("m-discount-eligible")!
  const _component_m_discount_inactive = _resolveComponent("m-discount-inactive")!
  const _component_m_token_exclusive_warning = _resolveComponent("m-token-exclusive-warning")!
  const _component_m_discount_available = _resolveComponent("m-discount-available")!
  const _component_m_add_to_cart_popup = _resolveComponent("m-add-to-cart-popup")!

  return (_ctx.loading || !_ctx.state.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_m_loading)
      ]))
    : (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!_ctx.getters.walletConnected && _ctx.getters.productHasCampaign)
            ? (_openBlock(), _createBlock(_component_m_discount_eligible, {
                key: 0,
                "nft-eligible-message": _ctx.nftEligibleMessage,
                "nft-eligible-title": _ctx.nftEligibleTitle,
                "custom-star-image": _ctx.customStarImage
              }, null, 8, ["nft-eligible-message", "nft-eligible-title", "custom-star-image"]))
            : (_ctx.getters.productHasCampaign && !_ctx.getters.campaignIsActive)
              ? (_openBlock(), _createBlock(_component_m_discount_inactive, {
                  key: 1,
                  "custom-star-image": _ctx.customStarImage
                }, null, 8, ["custom-star-image"]))
              : (_ctx.getters.walletConnected && _ctx.eligibleRewards.length == 0 && _ctx.getters.campaignIsActive)
                ? (_openBlock(), _createBlock(_component_m_token_exclusive_warning, {
                    key: 2,
                    "open-sea-collection-slug": _ctx.openSeaCollectionSlug,
                    "no-eligible-tokens-message": _ctx.noEligibleTokensMessage,
                    "no-eligible-tokens-title": _ctx.noEligibleTokensTitle,
                    "custom-star-image": _ctx.customStarImage
                  }, null, 8, ["open-sea-collection-slug", "no-eligible-tokens-message", "no-eligible-tokens-title", "custom-star-image"]))
                : (_ctx.getters.walletConnected && _ctx.eligibleRewards.length)
                  ? (_openBlock(), _createBlock(_component_m_discount_available, {
                      key: 3,
                      "nft-available-message": _ctx.nftAvailableMessage,
                      "nft-available-title": _ctx.nftAvailableTitle,
                      "custom-star-image": _ctx.customStarImage
                    }, null, 8, ["nft-available-message", "nft-available-title", "custom-star-image"]))
                  : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.getters.walletConnected && _ctx.eligibleRewards.length > 0 && _ctx.hasDiscount)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "manifold m-apply-discount-button",
                  disabled: _ctx.disabled,
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openPopup && _ctx.openPopup(...args)))
                }, _toDisplayString(_ctx.buttonText), 9, _hoisted_4))
              : (_ctx.getters.walletConnected && _ctx.eligibleRewards.length > 0 && !_ctx.hasDiscount)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "manifold m-add-to-cart-button",
                    disabled: _ctx.disabled,
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openPopup && _ctx.openPopup(...args)))
                  }, _toDisplayString(_ctx.buttonText), 9, _hoisted_5))
                : _createCommentVNode("", true),
            (_ctx.unrestricted)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  disabled: !_ctx.unrestricted || _ctx.isSoldOut,
                  class: "manifold m-add-to-cart-button",
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addToCartNormal && _ctx.addToCartNormal(...args)))
                }, _toDisplayString(_ctx.buttonCTA), 9, _hoisted_6))
              : _createCommentVNode("", true),
            (_ctx.popupIsOpen)
              ? (_openBlock(), _createBlock(_component_m_add_to_cart_popup, {
                  key: 3,
                  "add-to-cart-emojis": _ctx.addToCartEmojis,
                  "no-emojis": _ctx.noEmojis,
                  "cart-icon-section": _ctx.cartIconSection,
                  "reload-page-on-add-to-cart": _ctx.reloadPageOnAddToCart,
                  "redirect-to-cart": _ctx.redirectToCart,
                  onClose: _ctx.close
                }, null, 8, ["add-to-cart-emojis", "no-emojis", "cart-icon-section", "reload-page-on-add-to-cart", "redirect-to-cart", "onClose"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
}